import { Utilidades } from '../helper/utilidades';
import { Pagination } from './pagination.model';

export class PageList<T> {
  pageData: T[];
  pagination: Pagination;

  public static isPageList<T>(value: any): boolean {
    return Utilidades.isOfType<PageList<T>>(value, 'pageData');
  }
}
